<template>
  <page :name="_t('Dati aziendali')">
    <pf-page-section>
      <pf-flex align-items="stretch" gap="md">
        <pf-flex-item>
          <pf-card style="max-width: 70ch;">
            <pf-card-header>
              <pf-title h="3">{{ $t('Dati di fatturazione') }}</pf-title>
            </pf-card-header>
            <pf-card-body>
              <billing-form />
            </pf-card-body>
          </pf-card>
        </pf-flex-item>

        <pf-flex-item>
          <pf-card v-if="login.has_recurring_payments || login.verificato" style="max-width: 90ch;">
            <pf-card-header>
              <pf-title h="3">{{ _t('Modalità di pagamento') }}</pf-title>
            </pf-card-header>
            <pf-card-body class="pf-v6-c-form">
              <form-group :name="$t('Termini di pagamento')">
                {{ login.pagamento }}
              </form-group>

              <form-group :name="$t('Pagamenti ricorrenti')">
                <template v-if="login.has_recurring_payments">
                  <circle-icon color="green" /> {{ $t('I pagamenti automatici ricorrenti sono attivi. Tutte le prossime fatture verranno saldate automaticamente.') }}
                  <pf-button variant="danger" small :disabled="!login.grants.billing || sendingRecurringPayments" @click="disableRecurringPayments">
                    {{ $t("Disattiva") }}
                  </pf-button>
                </template>
                <template v-else>
                  <circle-icon color="red" /> {{ $t('I pagamenti automatici ricorrenti non sono attivi. Per attivarli spunta la relativa opzione effettuando il prossimo pagamento.') }}
                  <granted-link type="link" inline :disabled="!login.grants.billing" :to="{name: 'invoices'}">
                    {{ $t("Vai alle fatture") }}
                  </granted-link>
                </template>
              </form-group>
            </pf-card-body>
          </pf-card>
        </pf-flex-item>
      </pf-flex>
    </pf-page-section>
  </page>
</template>

<script lang="ts" setup>
import BillingForm from '../components/billing-form.vue';
import grantedLink from '@/components/granted-link.vue';
import { useLoginStore } from '@/store/login';
import { useAlertStore } from '@/store/alerts';
import { CompanyResource } from '@/resources';
import { $t as _t } from '@/i18n';
import { useFunctionRunningState } from '@common/use';
import CircleIcon from '@vue-patternfly/icons/circle-icon';

defineOptions({
  name: 'CompanyPage',
});

const login = useLoginStore();
const alert = useAlertStore();

const { isRunning: sendingRecurringPayments, run: disableRecurringPayments } = useFunctionRunningState(async() => {
  if (login.id_azienda === null || !confirm(_t('Sei sicuro di voler disattivare i pagamenti ricorrenti automatici?'))) {
    return;
  }

  await new CompanyResource().save(login.id_azienda, {
    disableRecurringPayments: true,
  });
  alert.add({ title: _t('Pagamenti automatici disattivati'), type: 'success', toast: true });
  await login.refresh();
}, { preventMultiple: true });
</script>
